import { WorkspaceBadge } from '../WorkspaceBadge';
import { useWorkspaceIcon } from '../../../lib/workspaces';
import styles from './FilesSpaceMark.module.css';

/**
 * Which Space a row belongs to, drawn as the Space's own badge rather than spelled out.
 *
 * Only the merged root needs to say this at all — it is the one listing where rows from different Spaces sit
 * side by side, so two "designs" folders (or two files of the same name) are otherwise indistinguishable.
 *
 * **The LIST shows the badge, not the name.** A name in that slot competes with the file name for the same
 * reading — two runs of words on one row, one of which repeats down every row of the same Space — where the
 * badge is recognised at a glance and costs 20px. The grid keeps the name: a tile has a line to spare and no
 * column to align with.
 *
 * The badge is `WorkspaceBadge`, the app's only Space avatar, so an icon edited anywhere repaints here too and
 * an icon-less Space still reads as its deterministic initials tile. The name rides along as the accessible
 * label and the hover title, because a glyph alone cannot be read aloud.
 */
export function FilesSpaceMark({ id, name, size = 20 }: { id?: string; name?: string; size?: number }) {
  const icon = useWorkspaceIcon(id ?? '');
  if (!id || !name) return null;
  return (
    <span className={styles.mark} title={name} aria-label={name} role="img">
      <WorkspaceBadge ws={{ id, name, icon }} size={size} />
    </span>
  );
}
